module.exports = __webpack_public_path__ + "202336:0ab57eca5a8d3a1f525a/img/sol-logo-guys-we-fcked.0861a0b.png";